import { Sparkles } from "lucide-react";

export const AI_LABEL = "LUMIS HR Assistant — Source-Guided";

// Product-facing AI label. Provider/model configuration is intentionally not shown to users.
export default function AiLabel() {
  return (
    <span data-testid="ai-label" className="inline-flex items-center gap-1.5 h-8 px-3 rounded-md border border-slate-300 bg-white text-xs font-semibold text-[#0A2A5E]">
      <Sparkles className="w-3.5 h-3.5 text-[#C7761A]" /> {AI_LABEL}
    </span>
  );
}
